import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  CardBody,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

import AddressCard from "./address-card";
import "../../assets/css/--component-account-address.css";
import { getCities, getUserAddress, postAddress, removeAddress, updateAddress } from "../../helper/backend-methods";
import T from "../../locale/translations-main";
import { use } from "react";
import { useAsyncError } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import ConfirmationModal from "../../components/StatusModal";
import mapPin from "../../assets/images/map-pin.png"

const AddressPage = () => {
  // JSON data containing all addresses with coordinates
  const [addModal, setAddModal] = useState(false);
  const [addFormData, setAddFormData] = useState({
    Title: "",
    StreetAddress: "",
    IsDefault: false,
    HouseNo: "",
    ZipCode: "",
    Country: "United States  of America",
  });
  const [marker, setMarker] = useState(null);
  const [mapError, setMapError] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [autoComplete, setAutoComplete] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 41.54, lng: -72.08 })
  const [mapMarker, setMapMarker] = useState({ lat: 41.54, lng: -72.08 })
  const [editMapMarker, setEditMapMarker] = useState({ lat: 0.00, lng: 0.00 })
  const [mapLoaded, setMapLoaded] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [editAddress, setEditAddress] = useState("");
  const [address, setAddress] = useState("")
  const searchRef = useRef("");
  const [street, setStreet] = useState("");
  const [editStreet, setEditStreet] = useState("");
  const [map, setMap] = useState(null);
  const [addressData, setAddressData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({
    title: "",
    address: "",
  });
  const [currentLocation, setCurrentLocation] = useState(null);
  const [editFormData, setEditFormData] = useState({
    Title: "",
    StreetAddress: "",
    IsDefault: false,
    HouseNo: "",
    ZipCode: "",
    Country: "United States of America",
  });
  const [userAddress, setUserAddress] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(true);

  const toggleAddModal = () => {
    setIsEditable(false);
    if (userAddress.length > 1) {
      setShowModal(true);
    } else {
      setMapCenter({ lat: 41.54, lng: -72.08 });
      setAddress("");
      setStreet("");
      setAddFormData({
        Title: "",
        StreetAddress: "",
        IsDefault: false,
        HouseNo: "",
        ZipCode: "",
        Country: "United States of America",
      });
      setErrors({ title: "", address: "", street: "", zipcode: "", city: "", province: "" });
      setAddModal(!addModal)
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    if (isEditable) {
      setEditFormData({
        ...editFormData,
        [name]: val,
      });
    } else {
      setAddFormData({
        ...addFormData,
        [name]: val,
      });
    }
  };


  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY,
    libraries: ['places']
  });

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
    setMapLoaded(false)
  }, [])

  const onLoad = (map) => {
    setAutoComplete(new window.google.maps.places.Autocomplete(searchRef.current
      //  , { componentRestrictions: { country: "US" } }
    ))
    const bounds = new window.google.maps.LatLngBounds(mapCenter);
    map.fitBounds(bounds);
    setMap(map)
    setMapLoaded(true)
  }

  const handleSaveAdd = () => {
    console.log("Add address data:", addFormData);
    // Implement save logic
    var zipcodeRE = new RegExp("^\\d{5}(-{1}\\d{4})?$");
    const errors = { title: "", address: "", street: "", zipcode: "", city: "", province: "" };
    let flag = false;
    if (!addFormData.Title || addFormData.Title.replaceAll(/\s/g, '').length < 1) {
      errors.title = <T>Address title is required</T>;
      flag = true
    }
    if (!address || address.replaceAll(/\s/g, '').length < 1) {
      errors.address = <T>Please provide a valid Address</T>;
      flag = true
    }
    if (!addFormData.ZipCode || addFormData.ZipCode.replaceAll(/\s/g, '').length < 1 || !zipcodeRE.test(addFormData.ZipCode)) {
      errors.zipCode = <T>Please provide a valid ZipCode</T>;
      flag = true
    }
    if (!street || street.replaceAll(/\s/g, '').length < 1) {
      errors.street = <T>Please provide a valid street address</T>;
      flag = true
    }

    setErrors(errors);
    if (!flag) {
      postAddress({
        Title: addFormData.Title,
        HouseNo: address,
        StreetAddress: street,
        ZipCode: addFormData.ZipCode,
        Coordinates: { Longitude: mapMarker.lng, Latitude: mapMarker.lat },
        IsDefault: addFormData.IsDefault
      }).then(({ data }) => {
        if (data.Status) {
          setAddFormData({});
          // Refresh address list after adding new address
          getAddressList();
        }
        toggleAddModal();
      }).catch((e) => {
        console.log(e);
        ///setCreateAddress(false)
        toggleAddModal();
      })
    }
    //toggleAddModal();
  }

  const handleEditAdd = (id) => {
    console.log("Add address data:", editFormData);
    // Implement save logic
    // var zipcodeRE = new RegExp("^\\d{5}(-{1}\\d{4})?$");
    // const errors = { title: "", address: "", street: "", zipcode: "", city: "", province: "" };
    // let flag = false;
    // if (!addFormData.title || addFormData.title.replaceAll(/\s/g, '').length < 1) {
    //   errors.title = <T>Address title is required</T>;
    //   flag = true
    // }
    // if (!addFormData.address || addFormData.address.replaceAll(/\s/g, '').length < 1) {
    //   errors.address = <T>Please provide a valid Address</T>;
    //   flag = true
    // }
    // if (!addFormData.zipcode || addFormData.zipcode.replaceAll(/\s/g, '').length < 1 || !zipcodeRE.test(addFormData.zipcode)) {
    //   errors.zipcode = <T>Please provide a valid ZipCode</T>;
    //   flag = true
    // }
    // if (!addFormData.province || parseInt(addFormData.province) === 0) {
    //   errors.province = <T>Please select event State/Province</T>;
    //   flag = true;
    // }
    // // if (!addFormData.city || parseInt(addFormData.city) === 0 || cities.filter(c => c.CityId === parseInt(addFormData.city)).length < 1) {
    // //   errors.city = <T>Please select event City/Town</T>;
    // //   flag = true;
    // // }
    // if (!addFormData.street || addFormData.street.replaceAll(/\s/g, '').length < 1) {
    //   errors.street = <T>Please provide a valid street address</T>;
    //   flag = true
    // }

    // setErrors(errors);
    // if (!flag) {
      updateAddress({
        id: id,
        Title: editFormData.Title,
        HouseNo: editAddress,
        StreetAddress: editStreet,
        ZipCode: editFormData.ZipCode,
        Coordinates: { Longitude: editMapMarker.lng, Latitude: editMapMarker.lat },
        IsDefault: editFormData.IsDefault
      }, "?addressId=" + id).then(({ data }) => {
        if (data.Status) {
          userAddress.forEach(addr => {
            if (addr.Id === id) {
              addr.Title = editFormData.Title;
              addr.HouseNo = editAddress;
              addr.StreetAddress = editStreet;
              addr.ZipCode = editFormData.ZipCode;
              addr.Coordinates = { Longitude: editMapMarker.lng, Latitude: editMapMarker.lat };
              addr.IsDefault = editFormData.IsDefault;
            } else {
              addr.IsDefault = false;
            }
          });
          setUserAddress([...userAddress.sort((a, b) => b.IsDefault - a.IsDefault)]);
        }
        toggleEditModal();
      }).catch((e) => {
        console.log(e);
        ///setCreateAddress(false)
        toggleEditModal();
      }).finally(() => {
        setErrors({ title: "", address: "", street: "", zipcode: "", city: "", province: "" });
      })
    // }
    toggleEditModal();
  }

  const onPlaceSelect = () => {
    const place = autoComplete.getPlace()
    if (place.geometry.viewport || place.geometry.location) {
      // console.log('place selected: ', place)
      setStreet(place.formatted_address)
      setEditStreet(place.formatted_address)
      setMapMarker({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      setEditMapMarker({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      setMapCenter({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      map.panTo({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() })
      map.setZoom(15)
    }
  }

  useEffect(() => {
    if (mapLoaded) {
      autoComplete.addListener('place_changed', onPlaceSelect)
    }
  }, [mapLoaded])

  const handleDelete = (address) => {
    setAddressData(address);
    setDeleteModal(true);
  };

  const makeDefault = (address) => {
    updateAddress({
      id: address.Id,
      Title: address.Title,
      HouseNo: address.HouseNo,
      StreetAddress: address.StreetAddress,
      ZipCode: address.ZipCode,
      Coordinates: { Longitude: address.Coordinates.Longitude, Latitude: address.Coordinates.Latitude },
      IsDefault: true
    }).then(({ data }) => {
      if (data.Status) {

        getAddressList();
      }
    }).catch((e) => {
      console.log(e);
    })
  }


  const handleSetDefault = (address) => {
    makeDefault(address);
  };

  const deleteAddress = (address) => {
    removeAddress("?addressId=" + address.Id).then((response) => {
      if (response.data.Status) {
        getAddressList();
      }
    }).catch((e) => {
      console.log(e)
    })
  }

  const getAddressList = () => {
    setLoading(true)
    getUserAddress().then(({ data }) => {
      if (data.Status) {
        setUserAddress(data.Data ? data.Data : [])
        setDisabled(data.Data && data.Data.length > 1 ? true : false);
      }
      setLoading(false)
    }).catch((e) => {
      console.log(e);
      setLoading(false)
    })
  }

  const toggleEditModal = () => {
    setErrors({ title: "", address: "", street: "", zipcode: "", city: "", province: "" });
    setEditModal(!editModal);
  };


  const getAddressFromCoordinates = (position) => {
    //   setBoundryError(false)
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: position }, (results, status) => {
      if (status === 'OK' && results[0]) {
        setStreet(results[0].formatted_address)
        setEditStreet(results[0].formatted_address)
      }
    });
  };

  const handleSaveEdit = () => {
    var zipcodeRE = new RegExp("^\\d{5}(-{1}\\d{4})?$");
    const errors = { title: "", address: "", street: "", zipcode: "", city: "", province: "" };
    let flag = false;
    if (!editFormData.title || editFormData.title.replaceAll(/\s/g, '').length < 1) {
      errors.title = <T>Address title is required</T>;
      flag = true
    }
    if (!editAddress || editAddress.replaceAll(/\s/g, '').length < 1) {
      errors.address = <T>Please provide a valid Address</T>;
      flag = true
    }
    if (!editFormData.ZipCode || editFormData.ZipCode.replaceAll(/\s/g, '').length < 1 || !zipcodeRE.test(editFormData.ZipCode)) {
      errors.zipcode = <T>Please provide a valid ZipCode</T>;
      flag = true
    }
    if (!editFormData.province || parseInt(editFormData.province) === 0) {
      errors.province = <T>Please select event State/Province</T>;
      flag = true;
    }
    // if (!addFormData.city || parseInt(addFormData.city) === 0 || cities.filter(c => c.CityId === parseInt(addFormData.city)).length < 1) {
    //   errors.city = <T>Please select event City/Town</T>;
    //   flag = true;
    // }
    if (!editStreet || editStreet.replaceAll(/\s/g, '').length < 1) {
      errors.street = <T>Please provide a valid street address</T>;
      flag = true
    }

    setErrors(errors);
    if (!flag) {
      handleEditAdd?.(addressData.Id);
      setEditModal(false);
    }
  };

  const handleConfirmDelete = () => {
    deleteAddress(addressData);
    setDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setDeleteModal(false);
  };

  const handleEdit = (address) => {
    setIsEditable(true);
    setAddressData(address);
    setEditFormData({
      Title: address.Title,
      HouseNo: address.HouseNo,
      StreetAddress: address.StreetAddress,
      ZipCode: address.ZipCode,
      Coordinates: address.Coordinates,
      IsDefault: address.IsDefault,
      Country: address.CountryName || "United States of America",
    });
    setEditAddress(address.HouseNo);
    setEditStreet(address.StreetAddress);
    setEditMapMarker({ lat: address.Coordinates.Latitude, lng: address.Coordinates.Longitude });
    //setMapCenter({ lat: address.Coordinates.Latitude, lng: address.Coordinates.Longitude });
    setEditModal(true);
  };

  const handleCancelSubmit = () => {
    setShowModal(false);
  };

  useEffect(() => {
    getAddressList();
  }, []);

  const getLocation = (e) => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        // Update map marker
        if (isEditable) {
          setEditMapMarker({ lat, lng });
        } else {
          setMapMarker({ lat, lng });
        }

        // Move map center
        setMapCenter({ lat, lng });
        if (map) {
          map.panTo({ lat, lng });
          map.setZoom(15);
        }

        // Reverse geocode → street address
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK" && results[0]) {
            const formatted = results[0].formatted_address;

            if (isEditable) {
              setEditStreet(formatted);
            } else {
              setStreet(formatted);
            }
          }
        });
      },
      (error) => {
        alert("Unable to retrieve your location.");
        console.error(error);
      }
    );
  };

  return (
    <section id="address-section" className="mt-5 ms-4">
      <div className="order-heading d-flex align-items-center justify-content-between mb-4 flex-column flex-lg-row">
        <h1 className="fs-30 text-blakish fw-600 m-0">Manage Addresses</h1>
        <button className="explore-menu-btn fs-16 fw-500" onClick={toggleAddModal} disabled={loading}><i className="ri-add-large-line"></i> &nbsp; ADD NEW ADDRESS</button>

      </div>
      <span className="separator my-3" />
      {userAddress.length === 0 && (
        <div className="text-center my-5">
          <i className="ri-map-pin-line" style={{ fontSize: "4rem", color: "#6c757d" }}></i>
          <h4 className="mt-3">No addresses found</h4>
          <p className="text-muted">You have not added any addresses yet. Click the button above to add your first address.</p>
        </div>
      )}
      <Row className="address-row">
        {userAddress.map((address) => (
          <Col key={address.Id} md={4} className="col-add mb-3">
            <AddressCard
              addressData={address}
              onEdit={() => handleEdit(address)}
              onDelete={() => handleDelete(address)}
              onSetDefault={handleSetDefault}
            />
          </Col>
        ))}
      </Row>

      <Modal isOpen={addModal} toggle={toggleAddModal} size="lg">
        <ModalHeader toggle={toggleAddModal}>Add Address</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="title">Address Title</Label>
                  <Input
                    type="text"
                    name="Title"
                    id="title"
                    placeholder="e.g., Home, Office"
                    value={addFormData.Title}
                    onChange={handleInputChange}
                  />
                  {errors.title ? <span className="txt-danger fs-12 fw-400">{errors.title}</span> : null}
                </FormGroup>

              </Col>
              <Col md={6}>

              </Col>
            </Row>
            <Row>

              <div className="address-form-content w-100 mt-3 mb-3">
                <div className="form-content mb-2">
                  <input placeholder='Search Here' ref={searchRef} className="pac-target-input" />
                </div>
                {isLoaded ?
                  <GoogleMap clickableIcons={false}
                    onClick={(e) => {
                      isEditable ? setEditMapMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() }) :
                        setMapMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() });
                      getAddressFromCoordinates({ lat: e.latLng.lat(), lng: e.latLng.lng() })
                    }}
                    center={mapCenter}
                    zoom={12}
                    onLoad={onLoad}
                    options={{ zoomControl: false, streetViewControl: false, mapTypeControl: false, maxZoom: 16 }}
                    mapContainerClassName={"map-container-modal"}
                    onUnmount={onUnmount}>
                    <Marker position={isEditable ? editMapMarker : mapMarker} />
                  </GoogleMap>
                  : <></>}


              </div>
              <span className="text-decoration-none text-blakish fs-18 d-flex align-items-center gap-1 mb-2" style={{ cursor: "pointer" }} onClick={getLocation}><img src={mapPin} alt="Location" />Use My Current Location</span>
            </Row>

            <FormGroup>
              <Label for="address">House No/Flat No</Label>
              <Input type="text" name="newAddress" id="newAddress" onChange={(e) => { isEditable ? setEditAddress(e.target.value.replace(/[^A-Za-zء-ي0-9\s#,\/\-\(\)\.]/g, '').slice(0, 50)) : setAddress(e.target.value.replace(/[^A-Za-zء-ي0-9\s#,\/\-\(\)\.]/g, '').slice(0, 50)) }} value={isEditable ? editAddress : address} placeholder={"House No/Flat No"} />
              {errors.address ? <span className="txt-danger fs-12 fw-400">{errors.address}</span> : null}
            </FormGroup>

            <FormGroup>
              <Label for="address">Street Address</Label>
              <Input type="text" name="newStreet" id="newStreet" onChange={(e) => { isEditable ? setEditStreet(e.target.value.slice(0, 100)) : setStreet(e.target.value.slice(0, 100)) }} value={isEditable ? editStreet : street} placeholder={"Street Address"} />
              {errors.street ? <span className="txt-danger fs-12 fw-400">{errors.street}</span> : null}
            </FormGroup>


            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="zipCode">ZIP Code</Label>
                  <Input
                    type="text"
                    name="ZipCode"
                    id="zipCode"
                    placeholder="12345"
                    value={addFormData.ZipCode}
                    onChange={handleInputChange}
                  />
                  {errors.zipCode ? <span className="txt-danger fs-12 fw-400">{errors.zipCode}</span> : null}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="country">Country</Label>
                  <Input type="text" name="country" id="country" value={addFormData.Country} disabled />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup check>
              <Input type="checkbox" name="IsDefault" id="isDefault" checked={addFormData.IsDefault} onChange={handleInputChange} />
              <Label for="isDefault" check>
                Set as default address
              </Label>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>

          <button className="explore-menu-btn" onClick={toggleAddModal}>
            Cancel
          </button>
          <button className="explore-menu-btn" onClick={handleSaveAdd}>
            Save Changes
          </button>
        </ModalFooter>
      </Modal>
      {/* Edit Address Modal */}
      <Modal isOpen={editModal} toggle={toggleEditModal} size="lg">
        <ModalHeader toggle={toggleEditModal}>Edit Address</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="title">Address Title</Label>
                  <Input
                    type="text"
                    name="Title"
                    id="title"
                    placeholder="e.g., Home, Office"
                    value={editFormData.Title}
                    onChange={handleInputChange}
                  />
                  {errors.title ? <span className="txt-danger fs-12 fw-400">{errors.title}</span> : null}
                </FormGroup>
              </Col>
              <Col md={6}>

              </Col>
            </Row>
            <Row>

              <div className="address-form-content w-100 mt-3 mb-3">
                <div className="form-content mb-2">
                  <input placeholder='Search Here' ref={searchRef} className="pac-target-input" />
                </div>
                {isLoaded ?
                  <GoogleMap clickableIcons={false}
                    onClick={(e) => {
                      isEditable ? setEditMapMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() }) :
                        setMapMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() });
                      getAddressFromCoordinates({ lat: e.latLng.lat(), lng: e.latLng.lng() })
                    }}
                    center={mapCenter}
                    zoom={12}
                    onLoad={onLoad}
                    options={{ zoomControl: false, streetViewControl: false, mapTypeControl: false, maxZoom: 16 }}
                    mapContainerClassName={"map-container-modal"}
                    onUnmount={onUnmount}>
                    <Marker position={isEditable ? editMapMarker : mapMarker} />
                  </GoogleMap>
                  : <></>}

                <span className="text-decoration-none text-blakish fs-18 d-flex align-items-center gap-1 mb-2" style={{ cursor: "pointer" }} onClick={getLocation}><img src={mapPin} alt="Location" />Use My Current Location</span>
              </div>
            </Row>
            <FormGroup>
              <Label for="address">House No/Flat No</Label>
              <Input type="text" name="newAddress" id="newAddress" onChange={(e) => { isEditable ? setEditAddress(e.target.value.replace(/[^A-Za-zء-ي0-9\s#,\/\-\(\)\.]/g, '').slice(0, 50)) : setAddress(e.target.value.replace(/[^A-Za-zء-ي0-9\s#,\/\-\(\)\.]/g, '').slice(0, 50)) }} value={isEditable ? editAddress : address} placeholder={"House No/Flat No"} />
              {errors.address ? <span className="txt-danger fs-12 fw-400">{errors.address}</span> : null}
            </FormGroup>

            <FormGroup>
              <Label for="address">Street Address</Label>
              <Input type="text" name="newStreet" id="newStreet" onChange={(e) => { isEditable ? setEditStreet(e.target.value.slice(0, 100)) : setStreet(e.target.value.slice(0, 100)) }} value={isEditable ? editStreet : street} placeholder={"Street Address"} />
              {errors.street ? <span className="txt-danger fs-12 fw-400">{errors.street}</span> : null}
            </FormGroup>


            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="zipCode">ZIP Code</Label>
                  <Input
                    type="text"
                    name="ZipCode"
                    id="zipCode"
                    placeholder="12345"
                    value={editFormData.ZipCode}
                    onChange={handleInputChange}
                  />
                  {errors.zipcode ? <span className="txt-danger fs-12 fw-400">{errors.zipcode}</span> : null}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="country">Country</Label>
                  <Input type="text" name="country" id="country" value={editFormData.Country} onChange={handleInputChange} disabled />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup check>
              <Input type="checkbox" name="IsDefault" id="isDefault" checked={editFormData.IsDefault} onChange={handleInputChange} />
              <Label for="isDefault" check>
                Set as default address
              </Label>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <button className="explore-menu-btn" onClick={toggleEditModal}>
            Cancel
          </button>
          <button className="explore-menu-btn" onClick={handleSaveEdit}>
            Save Changes
          </button>
        </ModalFooter>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModal} toggle={handleCancelDelete}>
        <ModalHeader toggle={handleCancelDelete}>Confirm Delete</ModalHeader>
        <ModalBody>
          <div className="text-center">
            <div className="delete-icon mb-3">
              <i className="ri-delete-bin-6-line" style={{ fontSize: "3rem", color: "#dc3545" }}></i>
            </div>
            <h5>Are you sure you want to delete this address?</h5>
            <p className="text-muted">
              <strong>{addressData.Title}</strong>
              <br />
              {addressData.StreetAddress}
            </p>
            <p className="text-danger">
              <small>This action cannot be undone.</small>
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <button className="explore-menu-btn" onClick={handleCancelDelete}>
            Cancel
          </button>
          <button className="explore-menu-btn" onClick={handleConfirmDelete}>
            Delete Address
          </button>
        </ModalFooter>
      </Modal>
      <ConfirmationModal
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        type="warning"
        title="Action Not Allowed"
        message={`You can't add more than 2 addresses.`}
        ButtonText="Back to Dashboard"
        onCancel={handleCancelSubmit}
      />
    </section>


  );
};

export default AddressPage;